import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Drawer, makeStyles, List, ListItem, Typography, Collapse } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router-dom';
import syncNavToPath from './syncNavToPath';
import color from '../../styles/color';
import ArrowForwardIos from '@material-ui/icons/ArrowForwardIos';
import BrandingColors from '../../styles/color';
import { useDispatch, useSelector } from "react-redux";
import { updateFormStatusSelector } from '../../redux/common/formValueChange/selectors'
import { updateDrawer } from '../../redux/common/formValueChange/action';
import { isMobileOrTablet } from '../../helper/drawerSetting';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { edit_role_get, side_BarMenu, user_admin_role, user_Role_Order, engagementAPIs } from '../../services/apiURL';
import { deleteApi, getApi, postApi, putApi } from '../../services/apiBase';
import { updateAccessSelector } from '../../redux/common/roleAccess/selectors';
import { userAccessConfiguration } from '../../redux/common/roleAccess/action';
import config from "../../services/config";
import GlobalSearchContainer from './GlobalSearchContainer';
import { useFeatureFlag } from '../../hooks/useFeatureFlag';
import { FEATURE_FLAGS, TX_CBM_WIZARD_MENU_ITEM_NAME, DATA_DICTIONARY_MENU_ITEM_NAME, PARKING_MENU_ITEM_NAME_PREFIX, ACCESSIBILITY_SERVICES_MENU_ITEM_NAME_PREFIX } from '../../config/featureFlags';



// Use SidebarItemData.json file in Manager/SMLite.Manager to add/update sidebar menu.
const drawerWidth = 275;
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        width: drawerWidth,
        '& .MuiAccordionSummary-content,& .MuiAccordion-root': {
            margin: 0
        },
        '& .Mui-expanded': {
            minHeight: 'auto'
        },
        '& .Mui-expanded .drawerButton': {
            color: color.lightBlue
        },
        '& .Mui-expanded button': {
            textTransform: 'none',
            borderRadius: 0
        },
        '@media (min-width: 1920px)': {
            width: '325px'
        }
    },
    drawer: {
        width: drawerWidth,
        '@media (min-width: 1920px)': {
            width: '325px'
        }
    },
    drawerPaper: {
        width: drawerWidth,
        top: 66,
        height: 'calc(100% - 80px)',
        '@media (min-width: 1920px)': {
            width: '325px'
        }
    },
    mainListWrapper: {
        padding: 0,
        '&::-webkit-scrollbar': {
            display: 'none'
        }
    },
    mainHeading: {
        borderLeft: '3px solid transparent',
        borderBottom: `1px solid ${color.lightGrey}`,
        padding: '6% 16px',
        height: '52px',
        color: color.blkSideBarFont,
        '& .MuiSvgIcon-root': {
            color: color.lightBlue
        },
        '& .MuiTypography-root': {
            marginLeft: '10px',
            width: '100%',
            fontFamily: 'FiraSans-Regular',
            fontSize: '16px',
            fontWeight: 600,
            "@media (min-width: 1920px)": {
                fontSize: '18px'
            }
        },
        '&:hover': {
            backgroundColor: `${color.lightBgOrange} !important`,
            borderLeft: `3px solid ${color.brightOrange}`
        },
        '& .arrow': {
            fontSize: '1em'
        }

    },
    mainHeadingOpened: {
        backgroundColor: `${color.lightBgOrange}`,
        borderLeft: `3px solid ${color.brightOrange}`,
        padding: '6% 16px',
        height: '52px',
        color: `${BrandingColors.blkSideBarFont}`,
        '&:hover': {
            backgroundColor: `${color.lightBgOrange} !important`
        },
        '& .MuiSvgIcon-root': {
            color: `${BrandingColors.blkSideBarFont}`,
        },
        '& .MuiTypography-root': {
            marginLeft: '10px',
            color: `${color.blkSideBarFont}`,
            width: '100%',
            fontFamily: 'FiraSans-Regular',
            fontWeight: 600,
            fontSize: '16px',
            "@media (min-width: 1920px)": {
                fontSize: '18px'
            }
        },
        '& .arrow': {
            fontSize: '1em',
            color: `${BrandingColors.blkSideBarFont}`,
            transform: 'rotate(90deg)'
        },
        '& *': {
            color: `${BrandingColors.blkSideBarFont}`,
        },
    },
    subHeading: {
        backgroundColor: `${color.greensidebarbg}`,
        borderBottom: `1px solid ${color.greensidebarbg}`,
        color: color.blkSideBarFont,
        padding: '6% 16px 6% 58px',
        height: '42px',
        '& .MuiSvgIcon-root': {
            color: color.lightBlue
        },
        '& .MuiTypography-root': {
            marginLeft: '10px',
            width: '100%',
            fontFamily: 'FiraSans-Regular',
            fontWeight: 500,
            fontSize: '16px',
            "@media (min-width: 1920px)": {
                fontSize: '18px'
            }
        },
        '&:hover': {
            backgroundColor: `${color.lightGreySidebar} !important`,
        },
        '& .arrow': {
            fontSize: '1em'
        }
    },
    subHeadingOpened: {
        backgroundColor: `${color.lightGreySidebar}`,
        borderBottom: `1px solid ${color.lightGreySidebar}`,
        padding: '6% 16px 6% 58px',
        height: '42px',
        '&:hover': {
            backgroundColor: `${color.lightGreySidebar} !important`,
        },
        '& .MuiSvgIcon-root': {
            color: color.lightBlue
        },
        '& .MuiTypography-root': {
            marginLeft: '10px',
            color: color.lightBlue,
            fontFamily: 'FiraSans-Regular',
            width: '100%',
            fontWeight: 500,
            fontSize: '16px',
            "@media (min-width: 1920px)": {
                fontSize: '18px'
            }
        },
        '& .arrow': {
            fontSize: '1em',
            color: `${BrandingColors.blkSideBarFont}`,
            transform: 'rotate(90deg)'
        },
        '& *': {
            color: `${BrandingColors.blkSideBarFont}`,
        },
    },
    nestedList: {
        overflowWrap: 'break-word',
        padding: '10px 16px 10px 70px',
        height: 'auto',
        minHeight: '44px',
        borderBottom: '1px solid #eee',
        borderLeft: '3px solid transparent',
        color: color.blkSideBarFont,
        backgroundColor: `${color.greensidebarbg}`,
        '& .MuiSvgIcon-root': {
            color: color.lightBlue
        },
        '& .MuiTypography-root': {
            marginLeft: '10px',
            fontFamily: 'FiraSans-Regular',
            width: '100%',
            fontWeight: 500,
            fontSize: '16px',
            "@media (min-width: 1920px)": {
                fontSize: '18px'
            }
        },
        '&:hover': {
            backgroundColor: `${color.lightGreySidebar} !important`,
        },
        '& .arrow': {
            fontSize: '1em'
        }
    },
    nestedListOpened: {
        padding: '10px 16px 10px 70px',
        height: 'auto',
        minHeight: '44px',
        color: `${BrandingColors.blkSideBarFont}`,
        backgroundColor: `${color.lightGreySidebar}`,
        '&.hasSublink': {
            backgroundColor: `${color.lightGreySidebar}`,
            color: `${BrandingColors.blkSideBarFont}`,
            borderLeft: '3px solid transparent'
        },
        '& .MuiSvgIcon-root': {
            color: color.lightBlue
        },
        '& .MuiTypography-root': {
            marginLeft: '10px',
            fontFamily: 'FiraSans-Regular',
            width: '100%',
            fontWeight: 500,
            fontSize: '16px',
            "@media (min-width: 1920px)": {
                fontSize: '18px'
            }
        },
        '&:hover': {
            backgroundColor: `${color.lightGreySidebar} !important`,
        },
        '& .arrow': {
            fontSize: '1em',
            color: `${BrandingColors.blkSideBarFont}`,
            transform: 'rotate(90deg)'
        },
        '& *': {
            color: `${BrandingColors.blkSideBarFont}`,
        },
    },
    subNestedList: {
        padding: '12px 16px 12px 80px',
        height: 'auto',
        minHeight: '48px',
        borderBottom: '1px solid #eee',
        backgroundColor: `${color.greensidebarbg}`,
        borderLeft: `3px solid transparent`,
        color: color.darkGreyFont,
        '& .MuiSvgIcon-root': {
            color: color.lightBlue
        },
        '& .MuiTypography-root': {
            marginLeft: '10px',
            fontFamily: 'FiraSans-Regular',
            width: '100%',
            fontWeight: 500,
            fontSize: '16px',
            "@media (min-width: 1920px)": {
                fontSize: '18px'
            }
        },
        '&:hover': {
            backgroundColor: `${color.lightGreySidebar} !important`,
        },
        '& .arrow': {
            fontSize: '1em'
        }
    },
    subNestedListOpened: {
        padding: '12px 16px 12px 80px',
        height: 'auto',
        minHeight: '48px',
        borderBottom: '1px solid #eee',
        color: `${color.darkBlack}`,
        backgroundColor: `${color.lightGreySidebar}`,
        '& .MuiSvgIcon-root': {
            color: color.lightBlue
        },
        '& .MuiTypography-root': {
            marginLeft: '10px',
            fontFamily: 'FiraSans-Regular',
            width: '100%',
            fontWeight: 500,
            fontSize: '16px',
            "@media (min-width: 1920px)": {
                fontSize: '18px'
            }
        },
        '&:hover': {
            backgroundColor: `${color.lightGreySidebar} !important`,
        },
        '& .arrow': {
            fontSize: '1em',
            color: `${BrandingColors.blkSideBarFont}`,
            transform: 'rotate(90deg)'
        },
        '& *': {
            color: `${BrandingColors.blkSideBarFont}`,
        },
    }
}));

const HelpAnchor = styled.a`
    text-decoration: none;
    color: ${BrandingColors.darkGreyFont}
`

// Same release notes site for every tenant. Asserted in Sidebar.releaseNotes.test.js.
const RELEASE_NOTES_URL = "https://status.siselements.com";

/** Should clicking a ROOT menu item navigate? Only when it has no children —
 *  items with subLinks expand/collapse in place (their bare module URLs have
 *  no pages). Exported for tests. */
export const shouldNavigateOnRootClick = (subLinks) =>
    !(Array.isArray(subLinks) && subLinks.length > 0);

const Sidebar = (props) => {
    const { t } = useTranslation()
    const classes = useStyles();
    const history = useHistory();
    const location = useLocation();
    const { sideBar, sideBarItems } = useSelector(updateFormStatusSelector);
    const [navItems, setNavItems] = useState(sideBarItems);
    const [pathName] = useState(window.location.pathname);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [confirmUpdate, setconfirmUpdate] = useState(false);
    const [url, setUrl] = useState(null);
    const dispatch = useDispatch();

    // Create loader overlay element once, cleanup on unmount:
    const elementRef = useRef(null);
    useEffect(() => {
        const el = document.createElement("div");
        document.body.appendChild(el);
        elementRef.current = el;
        return () => {
            if (el.parentNode) {
                el.parentNode.removeChild(el);
            }
        };
    }, []);

    const handleToggleDrawer = () => {
        dispatch(updateDrawer(!sideBar));
    };


    useEffect(() => {
        setNavItems(sideBarItems)
    }, [sideBarItems])

    // Sync sidebar expansion/highlight with the current route.
    // Covers deep-link navigation (global search) where the sidebar click
    // handlers are never invoked and the menu would otherwise stay collapsed.
    useEffect(() => {
        setNavItems((prev) => {
            const norm = (p) => (p && p.length > 1 && p.endsWith('/') ? p.slice(0, -1) : p);
            const target = norm(location.pathname);

            // If the currently active leaf already matches this pathname, skip.
            const activeMatchesCurrent = prev.some((root) =>
                (root.subLinks || []).some((sub) =>
                    (sub.subLinks || []).some((nested) => {
                        if (nested.isActive && (norm(nested.redirect) === target || norm(nested.url) === target)) return true;
                        return (nested.subLinks || []).some((deep) =>
                            deep.isActive && (norm(deep.redirect) === target || norm(deep.url) === target)
                        );
                    })
                )
            );
            if (activeMatchesCurrent) return prev;

            const synced = syncNavToPath(prev, location.pathname);
            return synced || prev;
        });
    }, [location.pathname])

    // Reusable function to handle external URLs
    const openExternalUrl = async (item) => {
        let url = null;

        if (item.name === 'menuItem.onlineHelp') {
            url = "/SM Lite Built Online Help/Default.htm";
            window.open(url, "_blank");
            return true;
        } else if (item.name === 'menuItem.releaseNotes') {
            window.open(RELEASE_NOTES_URL, "_blank", "noopener,noreferrer");
            return true;
        } else if (item.name === 'menuItem.engagement') {
            try {
                // Try to get client-specific URL from API
                const {data} = await getApi(engagementAPIs.get);
                
                if (data && data.data && data.data.engagementUrl) {
                    url = data.data.engagementUrl;
                } else {
                    // Fall back to default URL
                    url = "https://thesis.advising.app/login"
            }
            } catch (error) {
                console.error("Error fetching engagement URL:", error);
                // Fall back to default URL
                url = "https://thesis.advising.app/login"
            }

            window.open(url, "_blank");
            return true;
        }

        return false;
    };

    const handleMenuOpen = async (index, url, haveSubLinks, redirect, item, isReport) => {
        // Handle external URLs first — only show loader for external/async operations
        try {
            const isExternalUrl = await openExternalUrl(item);
            if (isExternalUrl) {
                return;
            }
        }
        catch (error) {
            console.error("Error getting external URL:", error);
            return;
        }

        redirect && localStorage.setItem("redirectUrl", redirect);
        document.getElementsByTagName('html')[0].classList.remove('popup-Page');
        setUrl(url);
        // Drawer condition for mobile,tablet and desktop
        if (typeof (haveSubLinks) === 'undefined' && isMobileOrTablet())
            handleToggleDrawer();
        let items = navItems.map((item, i) => {
            if (index === i) {
                return { ...item, isOpen: typeof item.isOpen === 'boolean' ? !item.isOpen : item.isOpen };
            } else {
                const updated = { ...item, isOpen: false };
                if (i !== index && navItems[index].subLinks) {
                    // Reset subLinks of the clicked item too
                }
                return updated;
            }
        });
        // Reset subLinks isOpen on siblings
        if (items[index].subLinks) {
            items[index] = {
                ...items[index],
                subLinks: items[index].subLinks.map(sub => ({ ...sub, isOpen: false }))
            };
        }
        // Root items with children expand/collapse ONLY. Their bare module
        // URLs (/admissions, /tools, ...) have no routes, so navigating just
        // bounced through the "*" catch-all to Home — yanking the user off
        // their current page for merely browsing the menu. Childless clicks
        // keep the pre-existing behaviour below, byte for byte.
        if (shouldNavigateOnRootClick(haveSubLinks)) {
            if (!isReport) {
                history.push(url);
            } else if (url) {
                if (haveSubLinks) {
                    history.push(url);
                } else {
                    window.open(url, '_blank');
                }
            }
        }
        setNavItems(items);
    };

    const handleSubLink = (index, subIndex, url, haveSubLinks, redirect) => {

        if (url && url.indexOf("INTEGRATION_API_SWAGGER_URL") > -1)
        {
            window.open(config.common.integrationApiSwaggerURL, '_blank');
            return;
        }

        document.getElementsByTagName('html')[0].classList.remove('popup-Page');
        redirect && localStorage.setItem("redirectUrl", redirect);
        let items = [...navItems];
        // Drawer condition for mobile,tablet and desktop
        if (typeof (haveSubLinks) === 'undefined' && isMobileOrTablet())
            handleToggleDrawer();
        if (url) {
            history.push(url);
        }
        const newSubLinks = items[index].subLinks.map((item, i) => {
            if (subIndex === i) {
                return { ...item, isOpen: item.subLinks ? !item.isOpen : true };
            } else {
                return { ...item, isOpen: false };
            }
        });
        // Reset subLinks of the clicked subItem
        if (newSubLinks[subIndex].subLinks) {
            newSubLinks[subIndex] = {
                ...newSubLinks[subIndex],
                subLinks: newSubLinks[subIndex].subLinks.map(sub => ({ ...sub, isOpen: false }))
            };
        }
        items[index] = { ...items[index], subLinks: newSubLinks };
        setNavItems(items);
        setUrl(url);
    };
    const handleSubNestedLink = (index, subIndex, nestedIndex, url, sublinks, redirect, isReport,IsModuleReport) => {
        document.getElementsByTagName('html')[0].classList.remove('popup-Page');
        redirect && localStorage.setItem("redirectUrl", redirect);

        // Drawer condition for mobile,tablet and desktop
        if (typeof (haveSubNestedLinks) === 'undefined' && isMobileOrTablet())
            handleToggleDrawer();
        let items = [...navItems];
        if (!isReport) {
            history.push(url);
        } else {
            if (url) {
                if (sublinks) {
                    history.push(url);
                } else {
                    if(IsModuleReport){
                        let temp = window.location.href.split("#");
                        window.open(temp[0]+"#"+url, '_self');
                    }else{
                        window.open(url, '_blank');
                    }
                }
            }
        }
        const newNestedLinks = items[index].subLinks[subIndex].subLinks.map((item, i) => {
            if (nestedIndex === i) {
                const updated = { ...item, isActive: true, isOpen: item.subLinks ? !item.isOpen : true };
                if (updated.subLinks) {
                    updated.subLinks = updated.subLinks.map(ite => ({ ...ite, isOpen: false, isActive: false }));
                }
                return updated;
            } else {
                return { ...item, isActive: false, isOpen: false };
            }
        });
        const newSubLinks = [...items[index].subLinks];
        newSubLinks[subIndex] = { ...newSubLinks[subIndex], subLinks: newNestedLinks };
        items[index] = { ...items[index], subLinks: newSubLinks };
        setNavItems(items);
        setUrl(url);
    };

    const handleSubSecondNestedLink = (index, subIndex, nestedIndex, subNestedIndex, url, redirect) => {
        document.getElementsByTagName('html')[0].classList.remove('popup-Page');
        redirect && localStorage.setItem("redirectUrl", redirect);
        if (isMobileOrTablet())
            handleToggleDrawer();
        if (!confirmUpdate) {
            let items = [...navItems];
            history.push(url);
            const newDeepLinks = items[index].subLinks[subIndex].subLinks[nestedIndex].subLinks.map((item, i) => {
                if (subNestedIndex === i) {
                    return { ...item, isActive: true, isOpen: item.subLinks ? !item.isOpen : true };
                } else {
                    return { ...item, isActive: false, isOpen: false };
                }
            });
            const newNestedLinks = [...items[index].subLinks[subIndex].subLinks];
            newNestedLinks[nestedIndex] = { ...newNestedLinks[nestedIndex], subLinks: newDeepLinks };
            const newSubLinks = [...items[index].subLinks];
            newSubLinks[subIndex] = { ...newSubLinks[subIndex], subLinks: newNestedLinks };
            items[index] = { ...items[index], subLinks: newSubLinks };
            setNavItems(items);
        }
        setUrl(url);
    };


    // Role based access control redux starts here
    const { access } = useSelector(updateAccessSelector)
    const { parentLevel, nestedParentLevel, subNestedParentLevel, subDeepNestedParentLevel } = access;
    const isCbmWizardEnabled = useFeatureFlag(FEATURE_FLAGS.TX_CBM_REPORTS);
    const isDataDictionaryEnabled = useFeatureFlag(FEATURE_FLAGS.DATA_DICTIONARY);
    const isParkingEnabled = useFeatureFlag(FEATURE_FLAGS.STUDENT_LIFE_PARKING);
    const isAccessibilityServicesEnabled = useFeatureFlag(FEATURE_FLAGS.STUDENT_LIFE_ACCESSIBILITY_SERVICES);
    const isAristotleHomeEnabled = useFeatureFlag(FEATURE_FLAGS.ARISTOTLE_HOME);
    const [parentLevels, setParentLevel] = useState([]);
    const [nestedParentLevels, setNestedParentLevel] = useState([]);
    const [subNestedParentLevels, setSubNestedParentLevel] = useState([]);
    const [subDeepNestedParentLevels, setSubDeepNestedParentLevel] = useState([]);

    useEffect(() => {
        let userID = localStorage.getItem('userId');
        let authMode = localStorage.getItem('authMode');
        //Loader Globally
        document.getElementById("root").style.display = "none";
        document.getElementsByTagName('body')[0].classList.add('loader-external-api');
        elementRef.current && elementRef.current.classList.add('api-request-loader');

        const abortController = new AbortController();            

        if (userID && authMode === 'cams') {
            getApi(`${user_Role_Order}/${userID}`, { signal: abortController.signal }).then((resp) => {
                const { menuList } = resp.data.data;
                const buckets = { 1: [], 2: [], 3: [], 4: [] };
                menuList.forEach(v => {
                    if (buckets[v.camsOrder]) buckets[v.camsOrder].push(v);
                });
                dispatch(userAccessConfiguration({
                    parentLevel: buckets[1],
                    nestedParentLevel: buckets[2],
                    subNestedParentLevel: buckets[3],
                    subDeepNestedParentLevel: buckets[4]
                }))
                //Loader Globally
                document.getElementsByTagName('body')[0].classList.remove('loader-external-api');
                elementRef.current && elementRef.current.classList.remove('api-request-loader');
                document.getElementById("root").style.display = "block";
            }).catch((err) => {
                document.getElementsByTagName('body')[0].classList.remove('loader-external-api');
                elementRef.current && elementRef.current.classList.remove('api-request-loader');
                document.getElementById("root").style.display = "block";
                console.log(err);
            })
        }

        return () => {
            abortController.abort();
        }

    }, [])

    // The Texas State Reports menu item is only visible while its feature flag is on.
    // Applied here rather than in the fetch above so the item appears/disappears once
    // FeatureFlagContext finishes loading (MainProtectedLayout fetches flags post-auth).
    const applyFeatureFlags = useCallback((menuItems) => {
        const hidden = [];
        if (!isCbmWizardEnabled) hidden.push(TX_CBM_WIZARD_MENU_ITEM_NAME);
        if (!isDataDictionaryEnabled) hidden.push(DATA_DICTIONARY_MENU_ITEM_NAME);
        // Whole modules hide as a group: the parent row and every child share a name prefix.
        const hiddenPrefixes = [];
        if (!isParkingEnabled) hiddenPrefixes.push(PARKING_MENU_ITEM_NAME_PREFIX);
        if (!isAccessibilityServicesEnabled) hiddenPrefixes.push(ACCESSIBILITY_SERVICES_MENU_ITEM_NAME_PREFIX);
        if (hidden.length === 0 && hiddenPrefixes.length === 0) return menuItems;
        return (menuItems || []).filter(v => {
            const name = v.menuItemName?.trim();
            if (name && hiddenPrefixes.some(prefix => name.startsWith(prefix))) return false;
            return !hidden.includes(name);
        });
    }, [isCbmWizardEnabled, isDataDictionaryEnabled, isParkingEnabled, isAccessibilityServicesEnabled])

    useEffect(() => {
        setParentLevel(applyFeatureFlags(parentLevel))
        setNestedParentLevel(applyFeatureFlags(nestedParentLevel))
        setSubNestedParentLevel(applyFeatureFlags(subNestedParentLevel))
        setSubDeepNestedParentLevel(applyFeatureFlags(subDeepNestedParentLevel))
    }, [parentLevel, nestedParentLevel, subNestedParentLevel, subDeepNestedParentLevel, applyFeatureFlags])

    // Role based access control redux ends here
    // Below if no access to any menu item then no access to reports either

    return (
        <Drawer
            {...props}
            className={classes.drawer}
            classes={{
                paper: classes.drawerPaper,
            }}
        >
            <GlobalSearchContainer />
            <List component="nav" className={classes.mainListWrapper} >
                {/* Home: static entry above the RBAC-driven module tree (the
                    items below only render when they match the user's
                    parentLevels menu-access rows — every user with the flag
                    gets a Home). /home hosts the embedded Aristotle assistant,
                    so the item only renders while aristotle_assistant_home is
                    on; flag off, the sidebar looks exactly as it did before
                    Aristotle (the /home route itself still resolves to the
                    legacy Dashboard for deep links and the catch-all). */}
                {isAristotleHomeEnabled && (
                    <ListItem
                        id={t('menuItem.home')}
                        button
                        onClick={() => {
                            document.getElementsByTagName('html')[0].classList.remove('popup-Page');
                            if (isMobileOrTablet()) handleToggleDrawer();
                            history.push('/home');
                        }}
                        className={location.pathname === '/home' ? classes.mainHeadingOpened : classes.mainHeading}
                    >
                        <i className="material-icons-outlined">home</i>
                        <Typography component="span">{t('menuItem.home')}</Typography>
                    </ListItem>
                )}
                {navItems.length > 0 && navItems.map((item, i) => (
                    <div key={i}>

                        <>
                            {/* Parent level access starts here*/}
                            {item.name !== 'Reports' &&
                                <>
                                    {parentLevels.length > 0 && parentLevels.map((v, index) => {
                                        if ((v.menuItemName.trim() === item.menuItemName?.trim() && v.menuAccess !== 0)) {
                                            return <ListItem key={index} id={t(item.name)} button onClick={() => handleMenuOpen(i, item.url, item.subLinks, item.redirect, item, false)} className={item.isOpen ? classes.mainHeadingOpened : classes.mainHeading}>
                                                <i className="material-icons-outlined">{item.icon}</i>
                                                <Typography component="span">{t(item.name)}</Typography>
                                                {item.subLinks && <ArrowForwardIos className='arrow' />}
                                            </ListItem>
                                        }
                                    })}
                                </>
                            }
                            {item.name === 'Reports' && parentLevels.filter(v => v.menuAccess !== 0).length > 0 &&
                                <>
                                    <ListItem id={t(item.name)} button onClick={() => handleMenuOpen(i, item.url, item.subLinks, item.redirect, item, true)} className={item.isOpen ? classes.mainHeadingOpened : classes.mainHeading}>
                                        <i className="material-icons-outlined">{item.icon}</i>
                                        <Typography component="span">{t(item.name)}</Typography>
                                        {item.subLinks && <ArrowForwardIos className='arrow' />}
                                    </ListItem>

                                </>
                            }
                            {item.menuItemName === 'onlineHelp' &&
                                <ListItem id={t(item.name)} button className={item.isOpen ? classes.mainHeadingOpened : classes.mainHeading} onClick={() => openExternalUrl(item)} >
                                    <i className="material-icons-outlined">{item.icon}</i>
                                    <Typography component="span">{t(item.name)}</Typography>
                                    {item.subLinks && <ArrowForwardIos className='arrow' />}
                                </ListItem>
                            }
                            {item.menuItemName === 'releaseNotes' &&
                                <ListItem id={t(item.name)} button className={item.isOpen ? classes.mainHeadingOpened : classes.mainHeading} onClick={() => openExternalUrl(item)} >
                                    <i className="material-icons-outlined">{item.icon}</i>
                                    <Typography component="span">{t(item.name)}</Typography>
                                    {item.subLinks && <ArrowForwardIos className='arrow' />}
                                </ListItem>
                            }
                            {/* Parent level access ends here*/}

                            {/* <ListItem id={t(item.name)} button onClick={() => handleMenuOpen(i, item.url, item.subLinks, item.redirect, item)} className={item.isOpen ? classes.mainHeadingOpened : classes.mainHeading}>
                            <i className="material-icons-outlined">{item.icon}</i>
                            {(item.name === 'menuItem.onlineHelp') ?
                                <Typography component="span">{<HelpAnchor href="/SM Lite Built Online Help/Default.htm" target={'_blank'}>{t(item.name)}</HelpAnchor>}</Typography>
                                :
                                <Typography component="span">{t(item.name)}</Typography>
                            }
                            {item.subLinks && <ArrowForwardIos className='arrow' />}
                        </ListItem> */}

                            <Collapse in={item.isOpen}>
                                {/* <List className={classes.mainListWrapper} > */}
                                    {item.subLinks && item.subLinks.map((subItem, itemIndex) => (
                                        <div key={itemIndex}>
                                            {/*Nested Parent level access starts here*/}
                                            {item.name !== 'Reports' &&
                                                nestedParentLevels.length > 0 && nestedParentLevels.map((v, index) => {
                                                    if ((v.menuItemName.trim() === subItem.menuItemName.trim() && v.menuAccess !== 0 && v.moduleorder === subItem.moduleorder)) {
                                                        return <ListItem key={index} id={t(subItem.name)} className={subItem.isOpen ? `${classes.subHeadingOpened} ${subItem.isActive ? 'active' : ''}` : `${classes.subHeading} ${subItem.isActive ? 'active' : ''}`} button onClick={() => handleSubLink(i, itemIndex, subItem.url, subItem.subLinks, subItem.redirect)}>
                                                            <Typography component="span">{t(subItem.name)}</Typography>
                                                            {subItem.subLinks && <ArrowForwardIos className='arrow' />}
                                                        </ListItem>
                                                    }
                                                })
                                            }
                                            {/*Nested Parent level access ends here*/}
                                            {item.name === 'Reports' &&
                                                parentLevels.length > 0 && parentLevels.map((v, index) => {
                                                    if ((v.menuItemName.trim() === subItem.menuItemName.trim() && v.menuAccess !== 0)) {
                                                        return <ListItem key={index} id={t(subItem.name)} className={subItem.isOpen ? `${classes.subHeadingOpened} ${subItem.isActive ? 'active' : ''}` : `${classes.subHeading} ${subItem.isActive ? 'active' : ''}`} button onClick={() => handleSubLink(i, itemIndex, subItem.url, subItem.subLinks, subItem.redirect, true)}>
                                                            <Typography component="span">{t(subItem.name)}</Typography>
                                                            {subItem.subLinks && <ArrowForwardIos className='arrow' />}
                                                        </ListItem>
                                                    }
                                                })
                                            }

                                            <Collapse in={subItem.isOpen}>
                                                {/* <List className={classes.mainListWrapper}> */}
                                                    {subItem.subLinks &&
                                                        subItem.subLinks.map((link, iKey) => (
                                                            <div key={iKey}>
                                                                {/*Sub Nested Parent level access starts here*/}
                                                                {item.name !== 'Reports' &&
                                                                    subNestedParentLevels.length > 0 && subNestedParentLevels.map((v, index) => {
                                                                        if ((v.menuItemName.trim() === link.menuItemName.trim() && v.menuAccess !== 0 && v.moduleorder === link.moduleorder && v.menulevel === link.menulevel)) {
                                                                            return <ListItem key={index} id={t(link.name)} className={link.isOpen ? `${classes.nestedListOpened} ${link.subLinks ? 'hasSublink' : ''} ${link.isActive ? 'active' : ''}` : `${classes.nestedList}`} button onClick={() => handleSubNestedLink(i, itemIndex, iKey, link.url, link.subLinks, link.redirect)}>
                                                                                <Typography component="span">{t(link.name)}</Typography>
                                                                                {link.subLinks && <ArrowForwardIos className='arrow' />}
                                                                            </ListItem>
                                                                        }
                                                                    })}
                                                                {/*Sub Nested Parent level access ends here*/}
                                                                {item.name === 'Reports' &&
                                                                    <ListItem id={t(link.name)} className={link.isOpen ? `${classes.nestedListOpened} ${link.subLinks ? 'hasSublink' : ''} ${link.isActive ? 'active' : ''}` : `${classes.nestedList}`} button onClick={() => handleSubNestedLink(i, itemIndex, iKey, link.url, link.subLinks, link.redirect, true,link.IsPowerBIReport)}>
                                                                        <Typography component="span">{link.name}</Typography>
                                                                        {link.subLinks && <ArrowForwardIos className='arrow' />}
                                                                    </ListItem>
                                                                }
                                                                <Collapse in={link.isOpen}>
                                                                    {/* <List className={classes.mainListWrapper}> */}
                                                                    {link.subLinks && link.subLinks.map &&
                                                                            link.subLinks.map((nl, indKey) =>
                                                                                <div key={indKey}>
                                                                                    {/*Sub Nested Parent level access starts here*/}
                                                                                    {item.name !== 'Reports' &&
                                                                                        subDeepNestedParentLevels.length > 0 && subDeepNestedParentLevels.map((v, index) => {
                                                                                            if ((v.menuItemName.trim() === nl.menuItemName.trim() && v.menuAccess !== 0 && v.moduleorder === nl.moduleorder && v.menulevel === nl.menulevel && v.parentorder === nl.parentorder)) {
                                                                                                return <ListItem key={index} id={t(nl.name)} button className={nl.isOpen ? `${classes.subNestedListOpened} ${nl.isActive ? 'active' : ''}` : `${classes.subNestedList} ${nl.isActive ? 'active' : ''}`} onClick={() => handleSubSecondNestedLink(i, itemIndex, iKey, indKey, nl.url, nl.redirect)}>
                                                                                                    <Typography component="span">  {t(nl.name)}
                                                                                                    </Typography>
                                                                                                </ListItem>
                                                                                            }
                                                                                        })}
                                                                                    {/*Sub Nested Parent level access ends here*/}
                                                                                    {item.name === 'Reports' &&
                                                                                        <ListItem id={t(nl.name)} button className={nl.isOpen ? `${classes.subNestedListOpened} ${nl.isActive ? 'active' : ''}` : `${classes.subNestedList} ${nl.isActive ? 'active' : ''}`}>
                                                                                            <Typography component="span">  {<HelpAnchor href={nl.url} target={'_blank'}>{nl.name}</HelpAnchor>}
                                                                                            </Typography>
                                                                                        </ListItem>
                                                                                    }
                                                                                </div>
                                                                            )
                                                                        }
                                                                    {/* </List> */}
                                                                </Collapse>
                                                            </div>
                                                        ))}
                                                {/* </List> */}
                                            </Collapse>
                                        </div>
                                    ))}
                                {/* </List> */}
                            </Collapse>
                        </>

                    </div>
                ))}
            </List>
        </Drawer>
    );
}

export default React.memo(Sidebar);
